<template>
  <div>
    <label :id="`${inputId}-label`" :for="inputId" :class="['form-label', { required: required }]">{{ label }}</label>
  </div>
  <slot :state="state"
        :inputId="inputId"
        :updateState="updateState"
        :required="required"
        :aria-labelledby="`${inputId}-label`"
        :aria-describedby="getAriaDescribedBy()"></slot>
  <div v-if="state && !showWarning" class="text-danger" role="alert" :id="`${inputId}-error`">{{ errorMessage }}</div>
  <div v-if="state && showWarning" class="mdh-text-warning" role="alert" :id="`${inputId}-warning`">{{ errorMessage }}</div>
  <div v-else-if="hint" class="hint ms-2 fs-small" :id="`${inputId}-hint`">{{ hint }}</div>
</template>

<script setup>
const emit = defineEmits(['update:state']);

const updateState = (value) => {
    emit('update:state', value);
};

const getAriaDescribedBy = () => {
  return props.errorMessage ? !props.showWarning ? `${props.inputId}-error` : `${props.inputId}-warning` : props.hint ? `${props.inputId}-hint` : '';
};

const props = defineProps({
  inputId: {
    type: String,
    required: true
  },
  label: {
    type: String,
    required: true
  },
  state: {
    type: Boolean,
    required: true
  },
  errorMessage: {
    type: String,
    default: ''
  },
  hint: {
    type: String,
    default: ''
  },
  required: {
    type: Boolean,
    default: false
  },
  showWarning: {
    type: Boolean,
    default: false
  }
});
</script>